import token from 'utils/csrf'

const HEADERS = {
  ...token,
  'Content-Type': 'application/json',
}

export function api (method, url, body) {
  let data = {
    method,
    headers: HEADERS,
    credentials: 'same-origin',
  }

  // need to have this extra for MS Edge
  if (body) data.body = JSON.stringify(body)

  return fetch(url, data).then(function(response) {
    if (response.status >= 200 && response.status < 300) {
      return Promise.resolve(response)
    } else {
      var error = new Error(response.statusText || response.status)
      error.response = response
      return Promise.reject(error)
    }
  })
}

export const apiDelete = (url, body) => api('delete', url, body)
export const apiPost = (url, body) => api('post', url, body)

export default api



// WEBPACK FOOTER //
// ./app/javascript/utils/api.js